/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DASHBOARD_ROUTE } from '../constants/RouteNameConstants';
import { checkForceUnclaimReset } from '../modules/authorization/Editor/actions';

function CustomAlert({ show, setShow, handleSubmitCloseModal }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const calimAPISuccessMessage = useSelector((state) => state?.CheckForceUnclaim?.user?.data?.resultMessage);

  const handleClose = () => {
    setShow(false);
    dispatch(checkForceUnclaimReset());
    navigate(DASHBOARD_ROUTE);
  };

  // Automatically handle modal close when it becomes visible
  useEffect(() => {
    if (show) {
      handleSubmitCloseModal();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title className="text-center">Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>{calimAPISuccessMessage || ''}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CustomAlert;
